import TagListPageReducer from './TagListPageReducer';

export default from './TagListPageContainer';

export const TagListPageReducers = {
  TagListPageReducer,
};
